import { observer } from 'mobx-react';

import './style.scss';

// type CertificaItem {
//     title: string;
//     content: string;
//     image: { url: string };
// }

const CertificationCard = observer(({ certificaItem }) => {
    return (
        <div className="certification-card">
            <div className='certification-card__header'>
                {certificaItem?.image?.url && (
                    <div className="certification-card__header__icon">
                        <img src={certificaItem?.image?.url} alt="icon" />
                    </div>
                )}
                <div className="certification-card__header__title">{certificaItem?.title}</div>
            </div>
            <div className="certification-card__list" style={{ whiteSpace: 'pre-wrap' }}>
                {certificaItem?.content}
            </div>
        </div>
    )
})

export default CertificationCard;
